import { z } from 'zod';
import { zStringRequired } from '../../z';
export const lvnSupervisoryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        evaluation: z.object({
            arrivesAsScheduled: zStringRequired(),
            followsPOC: zStringRequired(),
            positiveAttitude: zStringRequired(),
            reportsChanges: zStringRequired(),
            useUniversalPrecautions: zStringRequired(),
            ptConditionChanges: zStringRequired(),
            ptSatified: zStringRequired(),
            comments: z.string().optional(),
        }),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
